import { Box, BoxProps } from '../box/box';
import { flex } from './flex.css';
import { clsx } from 'clsx';

export type FlexProps = BoxProps;

export const Flex = <T extends HTMLElement = HTMLDivElement>(props: BoxProps<T>) => {
  return <Box {...props} className={clsx(flex, props.className)} />;
};
